var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenInNew = function SvgOpenInNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "open-in-new_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36.575 12.114h11.071L25.29 34.471l4.24 4.239 22.356-22.356v11.07h6.039V6.076h-21.35zm-30.5 45.81h44.957V35.417h-5.978v16.47h-32.94v-32.94h16.47v-5.978H6.075z",
    clipRule: "evenodd"
  })));
};
export { SvgOpenInNew as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTM2LjU3NSAxMi4xMTRINDcuNjQ2NEwyNS4yOSAzNC40NzA2TDI5LjUyOTMgMzguNzFMNTEuODg2IDE2LjM1MzZWMjcuNDI0OUg1Ny45MjVWNi4wNzQ5NUgzNi41NzVWMTIuMTE0Wk02LjA3NTAxIDU3LjkyNDlINTEuMDMyVjM1LjQxNkg0NS4wNTRWNTEuODg2SDEyLjExNFYxOC45NDZIMjguNTg0VjEyLjk2OEg2LjA3NTAxVjU3LjkyNDlaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";